var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ZonePriceTableAdmin',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams,"navTabs":_vm.navTabs},on:{"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"reload":_vm.reload}})
}
var staticRenderFns = []

export { render, staticRenderFns }